import agentSelectorComponent from './agent-selector.component';

const agentSelectorModule = angular.module('agentSelector', [
])
  .component('agentSelector', agentSelectorComponent)
  .name;

export default agentSelectorModule;
